import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
//使用use命令后才起作用
Vue.use(ElementUI)
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import axios from './api/global_variable'
import qs from 'qs';
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import { getAsyncRoutes } from '@/utils/asyncRouter'
import el from "element-ui/src/locale/lang/el";
import Print from 'vue-print-nb'

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

Vue.use(Print);
Vue.prototype.axios = axios;
Vue.prototype.qs = qs
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ElementUI, {
    size: 'small'
});
const i18n = new VueI18n({
    locale: 'zh',
    messages
});

let getRouter
const whiteList = ['/login'];
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | 补君堂互联网医疗系统`;
    const token = localStorage.getItem('authorization');
    if (token) {
        if (!getRouter) {
            if (to.path === '/login') {
                next()
            } else {
                getRouter = getAsyncRoutes(JSON.parse(localStorage.getItem('menus')));
                router.addRoutes(getRouter);
                next({...to, replace: true})
            }
        } else {
            if (to.path === '/login') {
                next()
            } else {
                next()
            }
        }
    } else {
        if (to.path === '/login') {
            next()
        } else {
            next('/')
        }
    }

    // if (to.path === '/login') {
    //     next()
    // } else if (!token && to.path !== '/login') {
    //     next('/login');
    // } else{
    //     const menu = JSON.parse(localStorage.getItem('menus'))
    //     const accessRoutes = getAsyncRoutes(menu);
    //     // 动态添加格式化过的路由
    //     router.addRoutes(accessRoutes);
    //     next()
    // }
});

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
